import _ from "lodash";
import React from "react";
import { Badge, Tooltip } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";
import ConditionalWrapper from "Utils/ConditionalWrapper";

import classes from "./ShortcutTooltip.scss";
import { tooltipOverlayStyle } from "./ShortcutTooltipStyles";

const ShortcutTooltip = props => {
  const {
    label,
    shortcutKeys,
    children,
    tooltipProps,
    showTooltip = true,
  } = props;

  const { t } = useI18n(["common"]);

  const getShortcutBadges = shortcutKeys => {
    return _.map(shortcutKeys, (key, index) => {
      return (
        <React.Fragment key={key}>
          {index !== 0 ? "+" : null}
          <Badge
            dsVersion="2.0"
            value={key}
            type="shortcut"
            shape="square"
            size="xxx-small"
          />
        </React.Fragment>
      );
    });
  };

  return (
    <ConditionalWrapper
      condition={showTooltip}
      wrapper={({ children }) => {
        return (
          <Tooltip
            dsVersion="2.0"
            theme="dark"
            tooltip={
              <div className={classes.tooltipContainer}>
                {label}
                {!_.isEmpty(shortcutKeys) ? (
                  <div className={classes.shortcutContainer}>
                    {!_.isArray(shortcutKeys[0])
                      ? getShortcutBadges(shortcutKeys)
                      : _.map(shortcutKeys, (keys, index) => {
                          return (
                            <React.Fragment key={index}>
                              {index !== 0
                                ? t("common:lowercase", {
                                    text: t("common:then"),
                                  })
                                : null}
                              {getShortcutBadges(keys)}
                            </React.Fragment>
                          );
                        })}
                  </div>
                ) : null}
              </div>
            }
            overlayStyle={tooltipOverlayStyle}
            showArrow
            {...tooltipProps}
          >
            {children}
          </Tooltip>
        );
      }}
    >
      {children}
    </ConditionalWrapper>
  );
};

export default ShortcutTooltip;
